import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RotateCcw, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const DeliveryPanel = () => {
  const [deliveries, setDeliveries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/admin/deliveries`, { withCredentials: true });
      setDeliveries(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleResend = async (id) => {
    try {
      const res = await axios.post(`${API}/api/admin/deliveries/${id}/resend`, {}, { withCredentials: true });
      alert(res.data.status === 'sent' ? 'Entrega reenviada!' : `Fallo: ${res.data.error || 'Error'}`);
      load();
    } catch (err) { alert('Error reenviando: ' + (err.response?.data?.detail || err.message)); }
  };

  if (loading) return <p className="text-white/40">Cargando entregas...</p>;

  return (
    <div data-testid="delivery-panel">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold">Registro de Entregas</h2>
          <p className="text-white/50 text-sm">Seguimiento de entregas por email.</p>
        </div>
        <button onClick={load} className="p-2 hover:bg-white/10 rounded-lg text-white/40"><RefreshCw className="w-4 h-4" /></button>
      </div>
      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-white/40 border-b border-white/10">
              <th className="p-4">ID Orden</th><th className="p-4">Producto</th><th className="p-4">Cliente</th>
              <th className="p-4">Estado</th><th className="p-4">Enviado</th><th className="p-4">Intentos</th><th className="p-4">Acciones</th>
            </tr></thead>
            <tbody>
              {deliveries.map(d => (
                <tr key={d.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`delivery-row-${d.id}`}>
                  <td className="p-4 font-mono text-xs text-white/50">{(d.order_id || '').slice(0, 14)}...</td>
                  <td className="p-4">
                    <p className="font-medium text-sm">{d.item_name}</p>
                    <p className="text-[10px] text-white/40">{(d.license_type || 'basic').toUpperCase()}</p>
                  </td>
                  <td className="p-4">
                    <p className="text-sm">{d.buyer_email}</p>
                    {d.buyer_name && <p className="text-[10px] text-white/40">{d.buyer_name}</p>}
                  </td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      d.status === 'sent' ? 'bg-green-500/20 text-green-400' :
                      d.status === 'failed' ? 'bg-red-500/20 text-red-400' :
                      'bg-yellow-500/20 text-yellow-400'
                    }`}>
                      {d.status === 'sent' ? 'Enviado' : d.status === 'failed' ? 'Fallido' : 'Pendiente'}
                    </span>
                    {d.error && <p className="text-[10px] text-red-400 mt-1 max-w-[200px] truncate" title={d.error}>{d.error}</p>}
                  </td>
                  <td className="p-4 text-white/40 text-xs">{d.sent_at ? new Date(d.sent_at).toLocaleString() : '-'}</td>
                  <td className="p-4 text-white/50 text-xs">{d.attempts}</td>
                  <td className="p-4">
                    <button onClick={() => handleResend(d.id)}
                      className="px-3 py-1.5 bg-[#E8720C]/10 hover:bg-[#E8720C]/20 text-[#E8720C] rounded-lg text-xs font-medium flex items-center gap-1 transition-colors"
                      data-testid={`resend-delivery-${d.id}`}>
                      <RotateCcw className="w-3 h-3" />Reenviar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {deliveries.length === 0 && <p className="text-center text-white/40 py-8">Sin entregas registradas.</p>}
      </div>
      {deliveries.length > 0 && (
        <div className="mt-4 flex items-center gap-4 text-xs text-white/40">
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-green-400" /> Enviados: {deliveries.filter(d => d.status === 'sent').length}</span>
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-red-400" /> Fallidos: {deliveries.filter(d => d.status === 'failed').length}</span>
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-yellow-400" /> Pendientes: {deliveries.filter(d => d.status === 'pending').length}</span>
        </div>
      )}
    </div>
  );
};

export default DeliveryPanel;
